import { DecodeHtml } from '../../utils/decodeHtml'
import { retrunAssets, returnNotImage } from '../../utils/getAssets'

const GAC = ({ college }) => {
  const about = DecodeHtml({ html: college?.aboutGAC?.markup })
  const committee = DecodeHtml({ html: college?.committee?.markup })
  const additionalInfo = DecodeHtml({ html: college?.additionalInfo?.markup })
  const youTubeChannels = college?.youtubeChannels?.items?.map(item => {
    item = item?.content?.properties
    return {
      img: item?.image ? retrunAssets(item?.image[0]?.url) : returnNotImage(),
      title: item?.link ? item?.link[0]?.title : '',
      link: item?.link ? item?.link[0]?.url : ''
    }
  })
  return (
    <div className='flex flex-col gap-8 p-4 md:px-10 w-full'>
      <div className='w-full'>{about}</div>
      <div className='grid grid-cols-1 lg:grid-cols-2  w-full gap-5'>
        <div>{committee}</div>
        <div className='flex flex-col gap-5 h-fit w-full'>
          {youTubeChannels?.map((d, i) => (
            <a
              key={i}
              href={d?.link}
              target='_blank'
              rel='noreferrer'
              className='flex items-center flex-wrap gap-5 h-fit w-full'
            >
              <img
                src={d?.img}
                alt={d?.title}
                className='w-full h-auto object-cover rounded-lg'
              />
              {/* <div className='flex flex-col gap-2'>
                <h1>{d?.title}</h1>
                <button className='px-8 py-2 bg-[#c80000] font-medium uppercase text-white rounded self-end'>
                  Subscribe
                </button>
              </div> */}
            </a>
          ))}
        </div>
      </div>
      <div className='w-full'>{additionalInfo}</div>
    </div>
  )
}

export default GAC
